var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"page"},[_c('div',{staticClass:"page-title"},[_c('h2',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"page-content",domProps:{"innerHTML":_vm._s(_vm.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }